import { type CollectionChainType, type EmojiId, type ResourceId, type UserDataKey } from '../common/structs';

const competitionUrl = `/admin/competitions`;
export const admin = {
    auth: (userId: ResourceId) => ({
        token: () => `/admin/auth/${userId}/token`,
        twoFactorAuth: () => ({
            disable: () => `/admin/auth/${userId}/2fa/disable`,
        }),
    }),
    // TODO: remove once this is moved to non-admin route on BE
    audit: {
        wishlist: `/admin/wishlists/audit`,
        items: `/admin/wishlist_items/audit`,
    },
    competitions: {
        collection: competitionUrl,
        competitionCollections: () => ({
            collection: `/admin/competitions/collections/`,
            // collectionBySlug: (slugs: string) => `${competitionCollectionsUrl}?slugs=${slugs}`,
            single: (slug: ResourceId, network: CollectionChainType) =>
                `/admin/competitions/network/${network}/collections/${slug}`,
        }),
        single: (slug: ResourceId) => ({
            competition: () => `${competitionUrl}/${slug}`,
            winners: () => `${competitionUrl}/${slug}/competition_winners`,
            updateWinner: (winnerId: ResourceId) => `${competitionUrl}/${slug}/competition_winners/${winnerId}`,
            updateBudget: () => `${competitionUrl}/${slug}/wishlists/update_budget`,
            wishlists: () => `${competitionUrl}/${slug}/wishlists`,
        }),
    },
    emoji: () => ({
        collection: () => `/admin/emoji_id`,
        tags: (eid: EmojiId) => ({
            collection: () => `/admin/emoji_id/${eid}/tags`,
        }),
        transfer: (eid: EmojiId) => ({
            single: () => `/admin/emoji_id/${eid}/transfer`,
        }),
        features: (eid: EmojiId) => ({
            single: () => `/admin/emoji_id/${eid}/features`,
        }),
        single: (eid: EmojiId) => `/admin/emoji_id/${eid}`,
    }),
    groups: () => ({
        collection: () => `/admin/groups`,
        single: (id: ResourceId) => `/admin/groups/${id}`,
    }),
    orders: () => ({
        collection: () => `/orders`,
    }),
    organizations: () => ({
        collection: () => `/organizations`,
    }),
    users: () => ({
        single: (id: ResourceId) => `/admin/users/${id}`,
        data: (key: UserDataKey, id: ResourceId) => `/admin/users/${id}/data/${key}`,
    }),
    gems: () => ({
        gems: () => `/admin/gems`,
        gemsById: (gemId: string) => `/admin/gems/${gemId}`,
        metadata: () => `/admin/artifacts/metadata`,
        ethAddresses: (gemId: string) => `/admin/gems/${gemId}/eth_addresses`,
    }),
    wallets: (userId: ResourceId) => ({
        syncNftWallet: () => `/admin/users/${userId}/sync_nft_wallet`,
    }),
};
